"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.join = exports.split = void 0;
var codec_1 = require("./codec");
var errors_1 = require("./errors");
var SessionStore = /** @class */ (function () {
    function SessionStore(name) {
        if (name === void 0) { name = ''; }
        this.name = name || 'default';
        this.sessionKey = "session-keystore-" + this.name;
        this.store = new Map();
        if (typeof window !== 'undefined') {
            this.rehydrate();
            this.addHookForUnload();
        }
    }
    SessionStore.prototype.set = function (key, value, expiresAt) {
        var d;
        if (expiresAt !== undefined) {
            d = typeof expiresAt === 'number' ? expiresAt : expiresAt.valueOf();
        }
        var item = {
            version: 1,
            value: value,
            expiresAt: d,
        };
        this.store.set(key, item);
    };
    SessionStore.prototype.delete = function (key) {
        this.store.delete(key);
    };
    SessionStore.prototype.get = function (key) {
        var now = Date.now();
        var item = this.store.get(key);
        if (!item) {
            return null;
        }
        if (item.expiresAt !== undefined && item.expiresAt <= now) {
            this.store.delete(key);
            return null;
        }
        return item.value;
    };
    SessionStore.prototype.clear = function () {
        this.store = new Map();
    };
    SessionStore.prototype.addHookForUnload = function () {
        window.addEventListener('unload', this.persist.bind(this));
    };
    SessionStore.prototype.persist = function () {
        if (typeof window === 'undefined') {
            throw new errors_1.ArcanaAuthException('SessionKeystore.persist is only available in the browser.');
        }
        var json = JSON.stringify(Array.from(this.store.entries()));
        var _a = (0, exports.split)(json), a = _a[0], b = _a[1];
        this.saveToWindowName(this.sessionKey, a);
        this.saveToSessionStorage(b);
    };
    SessionStore.prototype.rehydrate = function () {
        var a = this.loadFromWindowName(this.sessionKey);
        var b = this.loadFromSessionStorage(this.sessionKey);
        this.deleteFromSessionStorage(this.sessionKey);
        if (!a || !b) {
            return;
        }
        var json = (0, exports.join)(a, b);
        if (!json) {
            return;
        }
        var entries = JSON.parse(json);
        this.store = new Map(entries.map(function (_a) {
            var key = _a[0], item = _a[1];
            return [key, item];
        }));
    };
    SessionStore.prototype.saveToWindowName = function (name, val) {
        var obj = {};
        obj[name] = val;
        window.name = JSON.stringify(obj);
    };
    SessionStore.prototype.saveToSessionStorage = function (val) {
        window.sessionStorage.setItem(this.sessionKey, val);
    };
    SessionStore.prototype.loadFromWindowName = function (name) {
        if (!window.name) {
            return null;
        }
        var saved = JSON.parse(window.name);
        if (!(name in saved)) {
            return null;
        }
        var _a = saved, _b = name, out = _a[_b], safe = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
        var json = JSON.stringify(safe);
        window.name = json === '{}' ? '' : json;
        return out || null;
    };
    SessionStore.prototype.loadFromSessionStorage = function (key) {
        return window.sessionStorage.getItem(key);
    };
    SessionStore.prototype.deleteFromSessionStorage = function (key) {
        window.sessionStorage.removeItem(key);
    };
    return SessionStore;
}());
var split = function (secret) {
    var buff = codec_1.utf8.encode(secret);
    var rand1 = randomBytes(buff.length);
    var rand2 = new Uint8Array(rand1);
    for (var i in buff) {
        rand2[i] = rand2[i] ^ buff[i];
    }
    return [codec_1.b64.encode(rand1), codec_1.b64.encode(rand2)];
};
exports.split = split;
var join = function (a, b) {
    if (a.length !== b.length) {
        return null;
    }
    var aBuff = codec_1.b64.decode(a);
    var bBuff = codec_1.b64.decode(b);
    var output = new Uint8Array(aBuff.length);
    for (var i in output) {
        output[i] = aBuff[i] ^ bBuff[i];
    }
    return codec_1.utf8.decode(output);
};
exports.join = join;
var randomBytes = function (length) {
    return window.crypto.getRandomValues(new Uint8Array(length));
};
exports.default = SessionStore;
